import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SecurityService } from '../../../security/security.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { AdminEditUserComponent } from './admin-edit-user.component';

@Component({
  selector: 'app-admin-user-management',
  templateUrl: './admin-user-management.component.html',
  styles: [`
    .dashboard-container { padding: 2rem; }
    .table-container { overflow-x: auto; }
    .users-table { width: 100%; box-shadow: 0 4px 8px rgba(0,0,0,0.1); }
    .element-row:hover { background: #f5f5f5; }
    mat-form-field { width: 100%; margin-bottom: 1rem; }
  `],
  standalone: true,
  imports: [CommonModule, MaterialModule]
})
export class AdminUserManagementComponent implements OnInit {
  displayedColumns: string[] = ['id', 'loginId', 'emailVerified', 'created', 'updated', 'actions'];
  dataSource: MatTableDataSource<any>;
  loading = true;

  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private http: HttpClient,
    private securityService: SecurityService,
    private dialog: MatDialog
  ) { }

  private getHeaders() {
    const token = this.securityService.getAuthToken();
    const caid = this.securityService.getCaid();
    const headers: { [key: string]: string } = {};
    if (token) {
      headers['Authorization'] = token.startsWith('Bearer ') ? token : 'Bearer ' + token;
    }
    if (caid !== undefined && caid !== null) {
      headers['caid'] = caid.toString();
    }
    return { headers };
  }

  ngOnInit() {
    this.refreshData();
  }

  refreshData() {
    this.loading = true;
    this.http.get<any[]>(`${this.securityService.apiURL}/user`, this.getHeaders())
      .subscribe({
        next: (data) => {
          this.dataSource = new MatTableDataSource(data);
          this.dataSource.sort = this.sort;
          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to load users', err);
          this.loading = false;
        }
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  editUser(user: any) {
    const dialogRef = this.dialog.open(AdminEditUserComponent, {
      width: '500px',
      data: user
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.refreshData();
      }
    });
  }

  deleteUser(user: any) {
    if (user.loginId === 'ksolve-admin') {
      alert('Action not allowed: Cannot delete super admin user (ksolve-admin).');
      return;
    }
    if (confirm(`Are you sure you want to delete user ${user.loginId}? All associated relationships and subscriptions will be cleanly deleted.`)) {
      this.loading = true;
      this.http.delete(`${this.securityService.apiURL}/user/${user.id}`, this.getHeaders())
        .subscribe({
          next: () => {
            this.refreshData();
          },
          error: (err) => {
            console.error('Failed to delete user', err);
            alert('Failed to delete user: ' + (err.error?.message || err.message || 'Server error'));
            this.loading = false;
          }
        });
    }
  }
}
